import * as ko from "knockout";
import WorkItem from "../work-item";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import BaseViewModel from "./../../factories/base-view-model2";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";

/**
 * ViewModel for WorkItemDetailTab
 */
class WorkItemDetailTab extends BaseViewModel {
    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage);     

        this.SaveAllowed(false);

        this.WorkItem = parent;

        this.TabTitle(tabPage.Title());
    }

    //  #endregion

    // #region Properties

    /**
     * Work Item Object
     */
    WorkItem: WorkItem;

    // Bao object to access session objects
    Bao = Bao;

   
    /**
     * Title of Page
     */
    TabTitle = ko.observable<string>("");

    /**
     * Name of save permission
     * */
    PermissionSave = ko.observable("");

    /**
     * Name of refresh permission
     * */
    PermissionRefresh = ko.observable("");

    /**
     * Name of delete permission
     * */
    PermissionDelete = ko.observable("");

    /**
     * Name of qr code permission
     * */
    PermissionQRCode = ko.observable("");

    // #endregion

    //#region Public Methods


    InitUrl(): string {
        return "";
    }
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }




    // #endregion
}
export default WorkItemDetailTab;